import * as React from 'react';
import { useForm } from 'ClientApp/utils/rest-api';
import { FormControl, Button, Row, Col, Glyphicon } from 'react-bootstrap';
import { IQualityTestVariable, useQualityTestVariableApi } from '@nkr/models/qa/quality-test-variable';


interface IProps {
    variableKey: string;
    onClose: () => void;
}

const TaskVariableForm = (props: IProps) => {
    const api  = useQualityTestVariableApi();
    const form = useForm<IQualityTestVariable>(api, props.variableKey || null);

    form.setOnSaveComplete(() => {
        props.onClose();
    });

    return (
        <form onSubmit={form.handleSubmit} style={{marginBottom: '20px'}}>
            <Row style={{marginBottom: '20px'}}>
                <Col xs={6}>{form.data?.id}</Col>
                <Col xs={6}>
                    <FormControl
                        name="testValue"
                        type="text"
                        value={form.data?.testValue ?? ''}
                        onChange={form.handleStringChange}
                    />
                </Col>
            </Row>
            <Row style={{marginBottom: '20px'}}>
                <Col xs={12} style={{ textAlign: 'right' }}>
                    <Button bsStyle="primary" type="submit">
                        Update
                    </Button>
                </Col>
            </Row>
        </form>
    );
}

export default TaskVariableForm;